import React from "react";
import { getPatientById
,getScheduleByPatient, getTemplates, signedUrl,s3Upload,addFile,getFile
 } from "../../crud/auth.crud";
 import { Link } from "react-router-dom";
 import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import ReactS3Uploader from "react-s3-uploader"
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import { Figure } from "react-bootstrap";
import S3Image from "../../widgets/S3Image";
import CalendarEventsByPentity from "../../widgets/CalendarEventsByPentity";
import CreateSchedule  from "./CreateSchedule";

                  
export default class ViewPatient extends React.Component
{

	state = {
    	patients:[],
    	templates:[],
    	menu: false,
    	open:false,
  	}
	
constructor(props)
{
  super(props);
  this.state = {
      menu: false,
      patients:[],
      templates:[],
      patient:this.props.location.data,
      imageUrl:'media/misc/loading.gif',
      imageOpen:false,
    };
  
  console.log("patient id:::",this.props.location.data);
  this.toggleMenu = this.toggleMenu.bind(this);
  
}

handleClose = () =>
  {
    this.setState({open:false});
  }

  imageClose = () =>
  {
    this.setState({imageOpen:false});
  }

handleOpen = () =>
  {
    this.setState({open:true});
  }

getSignedUrl = (file, callback) =>
  {
    //this.setState({open:true});
    console.log("getSignedUrl");
    const params = {
    objectName: file.name,
    contentType: file.type
  };
    console.log(params);
	  signedUrl({ params })
	  .then(data => {
	    //callback(data.data);
	    //console.log(data.data);
	   // s3Upload(data.data.signedUrl,file,{headers:{'x-amz-acl': 'public-read','Content-Type' : params.contentType}})
	    s3Upload(data.data.signedUrl,file)
	    .then(response => response.data)
		    .then((data) => {
		     
		      	console.log(data);
		     });
	  })
	  .catch(error => {
	    //console.log(error);
	  });

}

 getUploadParams = async  ({ file, meta: { name } }) => {

 	console.log(this.state.patient.id);
 	let id = this.state.patient.id;
 	let url ="";
     await signedUrl({ name,id })
	  .then(data => {
  	 	url = data.data.signedUrl;
  	 	
  	})
	  //console.log("url 2===="+url);
	  //console.log("url===="+ url);
	  //console.log(file);
	  return { body: file, meta: {}, url:  url,method:'PUT'}
	}

   handleSubmit = (files, allFiles) => {
    //console.log(files.map(f => f.meta))
    //allFiles.forEach(f => f.remove())
    //console.log('here');
    //files.map((f) => (
    		//console.log(f.meta)
    	//))
  }

  imageView = (id,originalFileKey) => {
  	this.setState({imageUrl:'media/misc/loading.gif',imageOpen:true});
  	getFile(id,originalFileKey).then(response => response.data)
	      .then((data) => {
	      	this.setState({imageUrl: data.downloadUrl})
	      });
  }

 handleChangeStatus = ({ meta }, status) => {
    //console.log(status, meta)
    let id = this.state.patient.id;
    if(status=="done")
    {

    	addFile(id,meta.name,meta.size,meta.type).then(response => response.data)
	      .then((data) => {
	      		getPatientById(id).then(response => response.data)
			    .then((data) => {
			      this.setState({ patients: data })
			      //console.log(data);
			     });
	      });
    }
  }

 toggleMenu(){
 	//console.log("toggleMenu");
    this.setState({ menu: !this.state.menu })
  }
  
componentDidMount()
  {
  	let tempSchedules=[];
    if(this.props.location.data != null)
    {
    getPatientById(this.props.location.data.id).then(response => response.data)
    .then((data) => {
      this.setState({ patients: data })
      console.log("patient by id::::",data);
     });
    getTemplates().then(response => response.data)
    .then((data) => {
      this.setState({ templates: data })
      //console.log(data);
     });
    
  }
}

render()
{

	const show = (this.state.menu) ? "show" : "" ;
    return (
    	<>

    			
    						
							<div className="row">
								
								<div className="col-lg-8">
									<div className="kt-portlet">
										
										<div className="kt-portlet__body">
											
											{this.state.patients.length>0 &&

											<CreateSchedule pentities={this.state.patients} />
											}
											
										</div>
									</div>
								</div>
								{this.state.patients.length>0 && this.state.patients.map((patient) => (
								
								<div className="col-lg-4">
								
									
									
									<div className="row">
										<div className="kt-portlet" id="kt_portlet">
											<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													{/*<span className="kt-portlet__head-icon">
														<i className="flaticon-map-location"></i>
													</span>*/}
													
													<h3 className="kt-portlet__head-title">
														Referral Template
													</h3>
												</div>
												<div className="kt-portlet__head-toolbar">
													<div className="kt-portlet__head-group">
														<div className="btn-group">
															<button type="button" className="btn btn-elevate btn-danger dropdown-toggle" onClick={ this.toggleMenu } data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
																<i className="la la-plus"></i> Add Template
															</button>
															<div className={"dropdown-menu dropdown-menu-right "+ show}>
																{this.state.templates !== null && this.state.templates.map((template)=>(
																	<>
																<a className="dropdown-item" href="#">
																<Link
                    												to={{pathname:"/addtemplatedata", data: {template:template,patient:patient,fromPath:'/createpatientone'}}}
                    											>

																{template.templateName}</Link></a>
																	</>
																))}
																
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="kt-portlet__body">
												<div className="row">
												{ patient.templates != null &&
												<>
												{patient.templates.map((template)=>(
													<div className="col-lg-6">
													<p><Link to={{pathname:"/viewtemplatedata", data: {template:template,patient:patient,fromPath:'/createpatientone'}}}> {template.templateName}</Link></p>
													</div>
												))}
												</>
												}
												</div>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="kt-portlet" id="kt_portlet">
											<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													{/*<span className="kt-portlet__head-icon">
														<i className="flaticon-map-location"></i>
													</span>*/}
													<h3 className="kt-portlet__head-title">
														Imaging
													</h3>
												</div>
												<div className="kt-portlet__head-toolbar">
													<div className="kt-portlet__head-group">
														<div className="btn-group">
															<button type="button" className="btn btn-elevate btn-danger" onClick={ this.handleOpen } data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
																<i className="la la-plus"></i> Add Images
															</button>
															
														</div>
													</div>
												</div>
											</div>
											<div className="kt-portlet__body">
										
												<div className="kt-section">
													<div className="kt-section__content">
														<div className="row">
														{patient.files !=null &&
															<>
														{patient.files.map((file)=>(
															<div className="col-lg-6">
															<a href="#" onClick={()=>this.imageView(patient.id,file.previewFileKey)} className="kt-media kt-media--circle">
																<S3Image id={patient.id} originalFileKey={file.thumbFileKey}/>
																{file.fileName}
															</a>
															</div>
														))}
														</>
														}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									
								</div>
								))}
							</div>
							
						
							<Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
 
						        <DialogTitle id="form-dialog-title">Drag & Drop images to upload</DialogTitle>
						        <DialogContent>
						          {/*<DialogContentText>
						            Enter your notes for this schedule
						          </DialogContentText>*/}
						          <Dropzone
						          	accept="image/*,.stl"
						          	onChangeStatus={this.handleChangeStatus}
								    getUploadParams={this.getUploadParams}
								    styles={{ dropzone: { minHeight: 200, maxHeight: 250 } }}
								   />
						        </DialogContent>
      

						        <DialogActions>
						          <Button onClick={this.handleClose} color="primary">
						            Close
						          </Button>
						          
						        </DialogActions>
      
      						</Dialog>

      						<Dialog open={this.state.imageOpen} onClose={this.imageClose} aria-labelledby="form-dialog-title">
 
						        <DialogTitle id="form-dialog-title">Image Viewer</DialogTitle>
						        <DialogContent>
						          
						          <Figure>
						              <Figure.Image
						                
						                alt="171x180"
						                src={this.state.imageUrl}
						              />
              
            					</Figure>
						        </DialogContent>
      

						        <DialogActions>
						          <Button onClick={this.imageClose} color="primary">
						            Close
						          </Button>
						          
						        </DialogActions>
      
      						</Dialog>

									

    	</>
    	);
	}   
}